import React, { FC } from 'react'
import styled from 'styled-components'

import { HudSettingsPanel } from './HudSettingsPanel'
import { SettingsButton } from './SettingsButton'

const SettingsContainer = styled.div`
  position: relative;
  display: flex;
  align-items: flex-start;
`

const ButtonWrapper = styled.div`
  z-index: 10;
  position: relative;
`

interface HudSettingsOverlayContainerProps {
  isOpen: boolean
  onToggle: (isOpen: boolean) => void
}

export const HudSettingsOverlayContainer: FC<
  HudSettingsOverlayContainerProps
> = ({ isOpen, onToggle }) => {
  return (
    <SettingsContainer>
      <ButtonWrapper>
        <SettingsButton
          isSelected={isOpen}
          setIsSelected={() => onToggle(!isOpen)}
        />
      </ButtonWrapper>
      <HudSettingsPanel isOpen={isOpen} />
    </SettingsContainer>
  )
}
